export const divisionOfNumber = number => `${number}`.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,');
